<template>
  <div class="cookies-notice" v-if="b_show">
    <i class="icon icon-close" @click="close"></i>
    <p>{{ 'This website uses its own and third-party cookies and identifiers to improve accessibility and analyse our traffic. If you continue browsing, we consider that you accept its use. For more information visit our' | translate }} <router-link :to="{ path: $t('cookie-policy') }"> {{ 'Cookies Policy' | translate }} </router-link>.</p>
  </div>
</template>

<script>
    import CookiesNotice from '@views/common/CookiesNotice/cookies_notice'

    export default {
        mixins: [CookiesNotice]
    }
</script>


<style lang="scss">
.cookies-notice {
  position: fixed;
  bottom: 0;
  background-color: rgba(0,0,0,0.7);
  color: #fff;
  font-size: 14px;
  padding: 16px 50px;
  width: 100%;
  display: flex;
  justify-content: center;
  @media(max-width: 1199px) {
    padding: 12px 30px 12px 15px;
  }
  a {
    color: #fff;
    text-decoration: underline;
  }
  p {
    width: 100%;
    font-size: 10px;
    margin: 0;
    line-height: 1.8;
    text-align: center;
    @media(max-width: 1199px) {
      font-size: 8px;
      text-align: left;
    }
  }
  > i.icon-close {
    position: absolute;
    right: 24px;
    top: 50%;
    transform: translate(0,-50%);
    font-size: 7px;
    @media(max-width: 1199px) {
      top: 7px;
      right: 16px;
      transform: none;
      font-size: 7px;
    }
  }
}
</style>